import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminEmailHealth from "@/pages/admin/AdminEmailHealth";

export const Route = createFileRoute("/admin/email-health")({
  head: () => pageHead("Admin \u2014 Email Health \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminEmailHealth,
});
